import { NgIf, NgFor, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { footers } from 'src/_lib/interfaces/footer.interface';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-top-footer-ch4',
  templateUrl: './top-footer-ch4.component.html',
  styleUrls: ['./top-footer-ch4.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor,NgClass,RouterLink],
  encapsulation: ViewEncapsulation.None,

})
export class TopFooterCh4Component {
  cdnImagePath: string = environment.cdnImagePath;
    chTheme6 = environment.chTheme6;
  @Input() footerdata!: footers;
  @Input() footerwarning!: boolean;
  @Input() showContactDetails = false;
  @Input() isExternal!: (url: string) => boolean;
  @Output() linkClick = new EventEmitter<{
    event: Event;
    navLink: string;
    navname: string;
  }>();
  constructor(private browser: BrowserService) { }

  scrollTop() {
  this.browser.window?.scrollTo({ top: 0, behavior: 'smooth' });
}

  onClick(event: Event, navLink: string, navname: string) {
    this.linkClick.emit({ event, navLink, navname });
  }
}
